<p class="error-login" *ngIf="errorMessage"><i class="fa fa-times-circle-o"></i> {{errorMessage}}</p>